import { isErrorResponse, getErrorFromErrorResponse } from '@standardnotes/responses';
import { Result } from '@standardnotes/domain-core';
export class SendMessage {
    constructor(messageServer) {
        this.messageServer = messageServer;
    }
    async execute(params) {
        const response = await this.messageServer.createMessage({
            recipientUuid: params.recipientUuid,
            encryptedMessage: params.encryptedMessage,
            replaceabilityIdentifier: params.replaceabilityIdentifier,
        });
        if (isErrorResponse(response)) {
            return Result.fail(getErrorFromErrorResponse(response).message);
        }
        return Result.ok(response.data.message);
    }
}
